import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    anexo: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_ANEXOS_UP = 'GET_ALL_ANEXOS_UP'
const GET_ANEXO_UP_BY_ID = 'GET_ANEXO_UP_BY_ID'
const GET_ANEXO_UP_BY_ID_INFORME = 'GET_ANEXO_UP_BY_ID_INFORME'
const POST_ANEXO_UP = 'POST_ANEXO_UP'
const UPDATE_ANEXO_UP = 'UPDATE_ANEXO_UP'
const DELETE_ANEXO_UP = 'DELETE_ANEXO_UP'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllAnexosUp = createAsyncThunk(
    GET_ALL_ANEXOS_UP,
    async () => {
        try {
            const fullUrl = host + `Fi25anexo/obtenerAnexosUp`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las anexos: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getanexoById = createAsyncThunk(
    GET_ANEXO_UP_BY_ID,
    async (idanexo) => {
        try {
            const fullUrl = host + `Fi25anexo/obteneranexoById/${idanexo}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getanexoByIdInforme = createAsyncThunk(
    GET_ANEXO_UP_BY_ID_INFORME,
    async (idInforme) => {
        try {
            const fullUrl = host + `Fi25anexo/obteneranexoByIdInforme/${idInforme}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertanexo = createAsyncThunk(
    POST_ANEXO_UP,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexo/agregaranexo`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateanexo = createAsyncThunk(
    UPDATE_ANEXO_UP,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexo/actualizaranexo`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteanexo = createAsyncThunk(
    DELETE_ANEXO_UP,
    async (idanexo) => {
        try {
            const fullUrl = host + `Fi25anexo/eliminaranexo/${idanexo}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosanexoSlice = createSlice({

    name: 'metodosanexoSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllAnexosUp.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.anexo = payload.data.data

        },
        [getanexoById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.anexo = payload.data.data
        },
        [getanexoByIdInforme.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.anexo = payload.data.data
        },
        [insertanexo.fulfilled]: (state, { payload }) => {
        },

        [updateanexo.fulfilled]: (state, { payload }) => {

        },
        [deleteanexo.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosanexoSlice.actions
export const anexoReducer = metodosanexoSlice.reducer